import React from "react";
import { ReactComponent as DonorsChoose } from "svg/DonorsChoose.svg";

export default () => (
  <a className="HomeLink" href="https://donorschoose.org" target="_blank" rel="noopener noreferrer">
    <DonorsChoose />
  </a>
)